interface LegacyVehicle {
  color: string;
  plate: string;
  plateState: string;
  model: string;
  state: string;
}

/**
 * Returns the formatted vehicles with the names matching the db columns
 * @param vehicles - Arrays of unformatted vehicles
 * @param fieldNames - Field name to use to access vehicle color, plate, state and model
 * @example \{color: 'vehicleColor', plate: 'vehiclePlate', ...\}
 */
const defaultVehicleFieldNames: Partial<Record<'color' | 'plate' | 'state' | 'model', keyof LegacyVehicle>> = {
  color: 'color',
  plate: 'plate',
  state: 'state',
  model: 'model'
};
export const formatVehicles = (vehicles: LegacyVehicle[] | undefined, fieldNames: Partial<Record<'color' | 'plate' | 'state' | 'model', keyof LegacyVehicle>>) => {
  const fieldsMapping = {
    ...defaultVehicleFieldNames,
    ...fieldNames
  };
  const descriptionInfo = vehicles?.reduce((acc, v, i) => {
    const nb = i === 0 ? '' : i + 1; // pattern will be: vehicleColor, vehicleColor2
    return {
      ...acc,
      [`vehicleColor${nb}`]: fieldsMapping.color ? v[fieldsMapping.color] || null : null,
      [`licensePlate${nb}`]: fieldsMapping.plate ? v[fieldsMapping.plate] || null : null,
      [`state${nb}`]: fieldsMapping.state ? v[fieldsMapping.state] || null : null
    };
  }, {});
  // Add array of vehicle model uuids
  const vehicleUuids = vehicles ? vehicles.map(v => fieldsMapping.model ? v[fieldsMapping.model] : null) : [];
  return {
    ...descriptionInfo,
    vehicleUuids: vehicleUuids.filter(v => v !== null) as string[]
  };
};